import * as React from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import Title from '../components/Title';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';
import PublicHeader from '../components/PublicHeader';

export interface IPublicErrorPageProps {}

interface IPublicErrorPageState {
    height: number;
    scrollTo: string | null;
}

export default class PublicErrorPage extends React.Component<
    IPublicErrorPageProps,
    IPublicErrorPageState
> {
    constructor(props: IPublicErrorPageProps) {
        super(props);
        this.state = {
            height: 600,
            scrollTo: null
        };
    }

    componentWillMount() {
        this.setState({
            height: window.innerHeight - 323
        });
    }

    scrollTo(refName: string) {
        this.setState({
            scrollTo: refName
        });
    }

    render() {
        return (
            <div className="homepage">
                <PublicHeader scrollTo={e => this.scrollTo(e)} />

                {this.state.scrollTo && (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {
                                scrollTo: this.state.scrollTo
                            }
                        }}
                    />
                )}

                <div
                    className="errorPage"
                    style={{ minHeight: this.state.height }}
                >
                    <Title />

                    <div className="wrapper">
                        <h1>The page you are trying to reach does not exist</h1>
                        <p>
                            Please double-check the address. In case you are
                            using a sharing token to link a new shared dive with
                            your account, please verify that you have copied the
                            whole URL and pasted it into your address bar. If
                            you believe that the address is correct, please
                            contact us at{' '}
                            <Link to="mailto:support@wetnotes.com">
                                support@wetnotes.com
                            </Link>.
                        </p>
                    </div>
                </div>

                {/*tslint:disable-next-line:jsx-no-string-ref*/}
                <Footer ref="footer" logged={false} />

                <CookieConsent />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PublicErrorPage.tsx